import { types } from 'mobx-state-tree';

export interface RangeTimeProps {
  from: number;
  to: number;
}

export const RangeTime = types.model({
  from: types.number,
  to: types.number,
});

export default {
  RangeTime,
};
